import NotAllowed from "../../../../../components/error/not-allowed";
import { Permission } from "../../../../permission";
import { PERMISSIONS } from "../../../../role-control/constants";
import AbsenceLetterDetail from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import {
  MaternityLeaveCreate,
  MaternityLeaveEdit,
  MaternityLeaveList,
} from "../../absence-letter/pages/maternity-leave";

export const maternityLeaveDADRoutes = {
  maternityLeaveDADPage: {
    isAdmin: false,
    title: "2. Nghỉ thai sản",
    path: "/procedure/maternity-leave-dad",
    parentId: "procedure",
    component: () => {
      return (
        <MaternityLeaveList />

        // <Permission record={{ [PERMISSIONS["MATERNITY_LEAVE_DAD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <MaternityLeaveList />
        // </Permission>
      );
    },
  },
  createMaternityLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/maternity-leave-dad/create",
    parentId: "procedure",
    component: MaternityLeaveCreate,
  },
  detailMaternityLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/maternity-leave-dad/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editMaternityLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/maternity-leave-dad/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: MaternityLeaveEdit,
  },
};
